export default "__VITE_ASSET__IXdMuo8W__"